import React, { useEffect, useMemo, useState } from 'react'

import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { Button } from '@application/Interfaces/Molecules/Button'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Tabs } from '@icontainers/design-system/dist/organisms/Tabs'
import { StaticTradelaneType } from '@src/Application/Types/ComponentTypes'

import { RouteElement } from './RouteElement/RouteElement'
import { Link, RouteElementWrapper, TitleSection } from './StaticTradelane.styled'
import { getTab, handleTabChange } from './utils'

export const StaticTradelane = ({
    routesTitle,
    subtitle,
    link,
    linkLabel,
    routes,
    mode,
}: StaticTradelaneType): JSX.Element => {
    const { t } = useTranslation()

    const [selectedTab, setSelectedTab] = useState('')

    const tabs = getTab(routes)

    useEffect(() => {
        !selectedTab && setSelectedTab(tabs[0].value)
    }, [selectedTab, tabs])

    const routesContent = useMemo(() => routes.filter((r) => r.country === selectedTab), [routes, selectedTab])

    return (
        <TitleSection title={routesTitle} subtitle={subtitle} mode={mode}>
            <Tabs
                id="routes"
                size="default"
                variant="scrollable"
                tabs={tabs.map((tab) => ({ ...tab, label: t(tab.label) }))}
                onChangeCallback={handleTabChange(setSelectedTab)}
                className="tradeTab"
            />

            <Grid container mdUpSpacingTop={5} mdDownSpacingTop={3}>
                {routesContent.map((route, index) => (
                    <RouteElementWrapper
                        item
                        xs={12}
                        md={6}
                        key={`${index}-route.country`}
                        mdUpSpacingRight={6}
                        spacingTop={2}
                        spacingBottom={2}
                    >
                        <RouteElement {...route} />
                    </RouteElementWrapper>
                ))}
            </Grid>

            <Grid container justifyContent="center" spacingTop={10}>
                <Link to={link}>
                    <Button mode={mode}>{linkLabel}</Button>
                </Link>
            </Grid>
        </TitleSection>
    )
}
